import type { ReactNode } from 'react';

/**
 * The screen's two-column body, shared by the loaded view and its skeleton so
 * the skeleton is the same grid with nothing in it yet.
 */
export function OverviewBody(props: { main: ReactNode; side: ReactNode }): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
      <div className="flex flex-col gap-4 xl:col-span-2">{props.main}</div>
      <div className="flex flex-col gap-4">{props.side}</div>
    </div>
  );
}
